export enum RegistrationTypeEnum{
  Regulation = 1,
  Legacy = 2
}